import styled from 'styled-components';
import { Row,Col, Collapse, Drawer, Dropdown } from 'antd';
import { lightTheme } from '@/styles/themes/light';

const { fonts, palette } = lightTheme;

export const ActionPlanCardDropdown = styled(Dropdown)``;

export const ResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 56px;
	width: 100%;
`;

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const ScoresRow = styled(Row)`
	width: 100%;
`;

export const ScoreCard = styled.div`
	background-color: ${palette.secondary[100]};
	border-radius: 8px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
	justify-content: center;
	height: 100%;
`;

export const ScoreTitle = styled.div`
	font-size: ${fonts.body.lg.fontSize};
	font-weight: ${fonts.label.lg.fontWeight};
	line-height: ${fonts.body.lg.lineHeight};
	color: ${palette.secondary[400]};
	text-align: center;
`;

export const ScoreBadge = styled.div`
	color: ${palette.secondary.white};
	font-weight: ${fonts.label.lg.fontWeight};
	font-size: ${fonts.label.md.fontSize};
	background-color: ${palette.risk.very_high.default};
	border-radius: 4px;
	padding: 8px 16px;
	min-width: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ScoreValue = styled.span`
	font-size: ${fonts.body.lg.fontSize};
	font-weight: ${fonts.label.lg.fontWeight};
	line-height: ${fonts.body.lg.lineHeight};
	color: ${palette.secondary.white};
	text-align: center;
`;

export const ScoreValueActionPlan = styled.span`
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	line-height: ${fonts.label.md.lineHeight};
	color: ${palette.secondary.white};
	text-align: center;
`;

export const InfoCard = styled.div`
	background-color: ${palette.secondary[50]};
	border-radius: 8px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	height: 100%;
`;

export const InfoTitle = styled.div`
	font-size: ${fonts.body.lg.fontSize};
	font-weight: ${fonts.label.lg.fontWeight};
	line-height: ${fonts.body.lg.lineHeight};
	color: ${palette.secondary[400]};
`;

export const InfoText = styled.div`
	font-size: ${fonts.body.md.fontSize};
	font-weight: ${fonts.body.md.fontWeight};
	line-height: ${fonts.body.md.lineHeight};
	color: #505050;
`;

export const RiskLegendContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px 24px;
	padding: 8px;
`;

export const RiskLegendItem = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const RiskColorBox = styled.div<{ $color: string }>`
	width: 24px;
	height: 24px;
	border-radius: 6px;
	background-color: ${(props) => props.$color};
`;

export const RiskLabel = styled.span`
	font-size: ${fonts.body.md.fontSize};
	font-weight: ${fonts.body.md.fontWeight};
	line-height: ${fonts.body.md.lineHeight};
	color: ${palette.secondary[400]};
`;

export const AccordionHeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 24px;
`;

export const AccordionTitle = styled.h4`
	font-size: ${fonts.heading.sm.fontSize};
	font-weight: ${fonts.heading.sm.fontWeight};
	line-height: ${fonts.heading.sm.lineHeight};
	color: ${palette.secondary[400]};
	margin: 0;
`;

export const FactorsList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin: 0;
	padding: 0;
	list-style: none;
`;

export const FactorItem = styled.li`
	display: flex;
	gap: 8px;
	align-items: flex-start;
`;

export const WarningIcon = styled.span`
	color: ${palette.risk.moderate.default};
	font-size: ${fonts.body.md.fontSize};
	line-height: ${fonts.body.md.lineHeight};
	flex-shrink: 0;
`;

export const FactorText = styled.span`
	font-size: ${fonts.body.md.fontSize};
	font-weight: ${fonts.body.md.fontWeight};
	line-height: ${fonts.body.md.lineHeight};
	color: ${palette.secondary[500]};
	flex: 1;
`;

export const HeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const EmptyText = styled.p`
	color: ${palette.secondary[250]};
	font-size: ${fonts.body.md.fontSize};
	line-height: ${fonts.body.md.lineHeight};
	text-align: center;
	margin: 0;
	padding: 16px 0;
`;

export const PostureColumns = styled.div`
	display: flex;
	gap: 32px;
	width: 100%;
	padding-top: 16px;
	padding-left: 8px;
	padding-right: 8px;
`;

export const PostureColumn = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 16px;
	min-width: 0;
`;

export const PostureCardWrapper = styled.div`
	background-color: ${palette.secondary.white};
	border: 1px solid ${palette.secondary[200]};
	border-radius: 8px;
	padding: 24px;
	position: relative;
	display: flex;
	gap: 24px;
	align-items: center;
	justify-content: center;
`;

export const AccordionHeader = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
`;

export const ActionPlanAccordionTitle = styled.span`
	flex: 1;
	font-size: ${fonts.heading.sm.fontSize};
	font-weight: ${fonts.heading.sm.fontWeight};
	line-height: ${fonts.heading.sm.lineHeight};
	color: ${palette.secondary[400]};
`;

export const ActionPlanContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 24px 8px 0px 8px;
	max-height: 400px;
	overflow-y: auto;
`;

export const CardWrapper = styled.div`
	border-radius: 8px;
	overflow: hidden;
	position: relative;
`;

export const CardHeader = styled.div`
	background: ${palette.secondary[100]};
	height: 48px;
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CardTitle = styled.span`
	flex: 1;
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	line-height: 24px;
	letter-spacing: 0;
	color: ${palette.secondary[400]};
	text-align: center;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const CardMenuButton = styled.div`
	position: absolute;
	right: 8px;
	top: 8px;
	z-index: 1;
`;

export const CardMenuTrigger = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background: #e6eaf8;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	color: ${palette.primary.default};
`;

export const CardBody = styled.div`
	background: ${palette.secondary[50]};
	padding: 16px 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const MetaRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1;
`;

export const MetaRowCenter = styled(MetaRow)`
	justify-content: center;
	text-align: center;
`;

export const MetaRowEnd = styled(MetaRow)`
	justify-content: flex-end;
	text-align: right;

	@media (max-width: 1199px) {
		display: none;
	}
`;

export const MetaRowGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
`;

export const MetaLabel = styled.span`
	font-size: ${fonts.label.sm.fontSize};
	font-weight: ${fonts.label.sm.fontWeight};
	line-height: ${fonts.label.sm.lineHeight};
	letter-spacing: 0;
	color: ${palette.secondary[400]};
	white-space: nowrap;
`;

export const MetaValue = styled.span`
	font-size: ${fonts.body.sm.fontSize};
	font-weight: ${fonts.body.sm.fontWeight};
	line-height: ${fonts.body.sm.lineHeight};
	letter-spacing: -0.07px;
	color: ${palette.secondary[400]};
`;

export const MetaSeparator = styled.div`
	flex: 1;
`;

export const StatusGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const StatusDot = styled.span<{ $color: string }>`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ $color }) => $color};
`;

export const DescriptionRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 4px;
`;

export const CardDivider = styled.div`
	height: 1px;
	background: ${palette.secondary[150]};
	width: 100%;
`;

export const TaskSubHeader = styled.div`
	background: ${palette.secondary[100]};
	height: 48px;
	padding: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${fonts.label.sm.fontSize};
	font-weight: ${fonts.label.sm.fontWeight};
	line-height: ${fonts.label.sm.lineHeight};
	letter-spacing: 0;
	color: ${palette.secondary[400]};
`;

export const TaskRow = styled.div`
	display: flex;
	align-items: stretch;
	background: ${palette.secondary[50]};
	height: 48px;
`;

export const TaskCell = styled.div`
	flex: 1;
	padding: 16px;
	font-size: ${fonts.body.sm.fontSize};
	font-weight: ${fonts.body.sm.fontWeight};
	line-height: ${fonts.body.sm.lineHeight};
	letter-spacing: -0.07px;
	color: ${palette.secondary[400]};
	text-align: center;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TaskCellDivider = styled.div`
	width: 1px;
	height: 36px;
	align-self: center;
	background: ${palette.secondary[150]};
	flex-shrink: 0;
`;

export const PaginationRow = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
`;

export const PaginationLabel = styled.span`
	flex: 1;
	font-size: ${fonts.body.sm.fontSize};
	font-weight: ${fonts.body.sm.fontWeight};
	line-height: ${fonts.body.sm.lineHeight};
	letter-spacing: -0.07px;
	color: ${palette.secondary[400]};
`;

export const ActionPlanPagination = styled.div`
	.ant-pagination {
		display: flex;
		align-items: center;
		gap: 4px;
		margin: 0;
	}

	.ant-pagination-prev,
	.ant-pagination-next {
		min-width: 16px;
		width: 16px;
		height: 32px;
		line-height: 32px;
		margin: 0;
	}

	.ant-pagination-prev .ant-pagination-item-link,
	.ant-pagination-next .ant-pagination-item-link {
		border: none;
		background: transparent;
		padding: 0;
		min-width: 16px;
		width: 16px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: ${palette.secondary[250]};
	}

	.ant-pagination-item {
		width: 32px;
		min-width: 32px;
		height: 32px;
		line-height: 32px;
		background: ${palette.secondary[100]};
		border: none;
		border-radius: 4px;
		margin: 0;
	}

	.ant-pagination-item a {
		font-size: ${fonts.label.sm.fontSize};
		font-weight: ${fonts.label.sm.fontWeight};
		line-height: ${fonts.label.sm.lineHeight};
		letter-spacing: 0;
		color: ${palette.secondary[250]};
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		padding: 0;
	}

	.ant-pagination-item-active {
		background: #e6eaf8;
		border: none;
	}

	.ant-pagination-item-active a {
		color: ${palette.primary.default};
		font-weight: ${fonts.label.sm.fontWeight};
	}

	.ant-pagination-disabled .ant-pagination-item-link {
		color: ${palette.secondary[150]};
		border: none;
		background: transparent;
	}
`;

export const RequiredMark = styled.span`
	color: #e74150;
	margin-left: 2px;
`;

export const ModalRiskBadge = styled.div`
	background: ${palette.risk.very_high.default};
	border-radius: 4px;
	padding: 8px 16px;
	min-width: 48px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
`;

export const ModalRiskBadgeText = styled.span`
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	line-height: ${fonts.label.md.lineHeight};
	letter-spacing: ${fonts.label.md.letterSpacing};
	color: ${palette.secondary.white};
`;

export const InvestmentButtonGroup = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
`;

export const InvestmentButton = styled.button<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	min-width: 40px;
	height: 40px;
	border-radius: 4px;
	border: 1px solid ${({ $active }) => ($active ? '#2F54EB' : palette.secondary[150])};
	background: ${({ $active }) => ($active ? '#E6EAF8' : palette.secondary.white)};
	cursor: pointer;
	font-size: 16px;
	font-weight: ${fonts.label.md.fontWeight};
	color: ${palette.secondary[400]};
	transition: background 0.2s, border-color 0.2s;
`;

export const DrawerFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
`;

export const TasksSectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
`;

export const TasksAddRow = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	width: 100%;

	.ant-input-affix-wrapper,
	.ant-input {
		flex: 1;
	}
`;

export const TaskIconButton = styled.button<{ $plus?: boolean; $danger?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	flex-shrink: 0;
	border-radius: 6px;
	border: 1px solid ${palette.secondary[150]};
	background: ${palette.secondary.white};
	color: ${({ $plus, $danger }) => ($danger ? '#ff4d4f' : $plus ? palette.secondary[400] : '#2f54eb')};
	font-size: 16px;
	cursor: pointer;
	transition: border-color 0.2s, color 0.2s;

	&:hover {
		border-color: ${({ $danger }) => ($danger ? '#ff4d4f' : '#2f54eb')};
		color: ${({ $danger }) => ($danger ? '#ff4d4f' : '#2f54eb')};
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}
`;

export const TasksListWrapper = styled.div`
	max-height: 200px;
	overflow-y: auto;
	width: 100%;

	.ant-list-sm .ant-list-item {
		padding: 16px 0;
	}

	.ant-list-item-action-split {
		display: none;
	}
`;

export const TaskItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	background: ${palette.secondary[50]};
	border: 1px solid ${palette.secondary[150]};
	border-radius: 6px;
	gap: 8px;
`;

export const TaskEditRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1;
`;

export const TaskTitle = styled.span`
	flex: 1;
	font-size: ${fonts.body.sm.fontSize};
	color: ${palette.secondary[400]};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const AttachmentButton = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 152px;
	height: 184px;
	padding: 8px;
	background: ${palette.secondary.white};
	border: 1px solid ${palette.secondary[150]};
	border-radius: 8px;
	cursor: pointer;
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	color: ${palette.secondary[400]};
`;

export const CloseAllButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	font-size: ${fonts.body.sm.fontSize};
	font-weight: ${fonts.body.sm.fontWeight};
	line-height: ${fonts.body.sm.lineHeight};
	color: ${palette.primary.default};
	cursor: pointer;
	text-decoration: none;

	&:focus {
		outline: none;
	}
`;

export const StyledCollapse = styled(Collapse)`
	background-color: transparent;
	border: none;
	display: flex;
	flex-direction: column;
	gap: 24px;

	.ant-collapse-item {
		border-radius: 0 !important;
		border: none !important;
	}

	.ant-collapse-header {
		padding: 16px 8px !important;
		align-items: center !important;
		border: none !important;
		border-bottom: 1px solid ${palette.secondary[200]} !important;
	}

	.ant-collapse-item:hover .ant-collapse-header {
		background-color: ${palette.secondary[100]} !important;
	}

	.ant-collapse-content {
		border: none !important;
	}

	.ant-collapse-content-box {
		padding: 0;
	}

	.ant-collapse-expand-icon {
		color: ${palette.secondary[250]};

		.anticon {
			font-size: 16px !important;
		}
	}
`;

export const CategoryHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: 24px;
`;

export const CategoryTitle = styled.span`
	font-size: ${fonts.heading.sm.fontSize};
	font-weight: ${fonts.heading.sm.fontWeight};
	line-height: ${fonts.heading.sm.lineHeight};
	color: ${palette.secondary[400]};
	flex: 1;
`;

export const ScoreBadgeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin-right: 46px;
`;

export const ScoreLabel = styled.span`
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	line-height: ${fonts.label.md.lineHeight};
	color: ${palette.secondary[400]};
`;

export const CommentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const CommentTitle = styled.h3`
	font-size: ${fonts.heading.md.fontSize};
	font-weight: ${fonts.heading.md.fontWeight};
	line-height: ${fonts.heading.md.lineHeight};
	color: ${palette.secondary[400]};
	margin: 0;
`;

export const VerticalRiskContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const RiskRow = styled.div`
	display: flex;
	gap: 24px;
	width: 100%;
`;

export const RiskScoreColumn = styled.div`
	flex: 0 0 auto;
	width: 200px;
`;

export const RiskInfoColumns = styled(Row)`
	flex: 1;
	min-width: 0;
`;

export const ReportHeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const HeaderTop = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
	width: 100%;

	@media (max-width: 1199px) {
		flex-wrap: wrap;
		justify-content: space-between;
		row-gap: 16px;
	}
`;

export const LogoKinebot = styled.img`
	width: 200px;
	height: auto;
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 0;

	@media (max-width: 1199px) {
		flex: 0 0 100%;
		order: 3;
	}
`;

export const SubTitle = styled.div`
	font-size: ${fonts.body.lg.fontSize};
	font-weight: ${fonts.body.lg.fontWeight};
	line-height: ${fonts.body.lg.lineHeight};
	letter-spacing: -0.09px;
	color: ${palette.secondary[400]};
`;

export const MainTitle = styled.div`
	font-size: ${fonts.heading.md.fontSize};
	font-weight: ${fonts.heading.md.fontWeight};
	line-height: ${fonts.heading.md.lineHeight};
	letter-spacing: -0.125px;
	color: ${palette.secondary[400]};
`;

export const ClientLogo = styled.img`
	width: 10.625rem;
	height: 4.375rem;
	object-fit: contain;
	flex-shrink: 0;
`;

export const InfoSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
`;

export const InfoSectionTitle = styled.h2`
	font-size: ${fonts.heading.md.fontSize};
	font-weight: ${fonts.heading.md.fontWeight};
	line-height: ${fonts.heading.md.lineHeight};
	letter-spacing: -0.125px;
	color: ${palette.secondary[400]};
	margin: 0;
`;

export const InfoGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 40px;
	row-gap: 8px;
	width: 100%;
`;

export const InfoColumn = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const InfoLastColumn = styled.div`
	flex: 0 0 100%;
	display: flex;
	flex-direction: column;
	gap: 8px;
	word-break: break-word;
`;

export const VerticalDivider = styled.div`
	width: 1px;
	background-color: ${palette.secondary[150]};
	align-self: stretch;
`;

export const InfoRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	column-gap: 4px;
	row-gap: 0;
	font-size: ${fonts.body.md.fontSize};
	line-height: ${fonts.body.md.lineHeight};
`;

export const InfoLabel = styled.span`
	font-weight: ${fonts.label.md.fontWeight};
	color: ${palette.secondary[400]};
	flex-shrink: 0;
`;

export const InfoValue = styled.span`
	font-weight: ${fonts.body.md.fontWeight};
	color: ${palette.secondary[400]};
	letter-spacing: -0.08px;
`;

export const FullWidthInfoRow = styled.div`
	display: flex;
	gap: 4px;
	font-size: ${fonts.body.md.fontSize};
	line-height: ${fonts.body.md.lineHeight};
	width: 100%;
`;

export const AccordionContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 16px 8px 0px 8px;
`;

export const ContentText = styled.p`
	font-size: ${fonts.body.md.fontSize};
	font-weight: ${fonts.body.md.fontWeight};
	line-height: ${fonts.body.md.lineHeight};
	color: ${palette.secondary[500]};
	margin: 0;
`;

export const ContentRow = styled.div`
	display: flex;
	gap: 8px;
	font-size: ${fonts.body.md.fontSize};
	line-height: ${fonts.body.md.lineHeight};
`;

export const ContentLabel = styled.span`
	font-weight: ${fonts.label.md.fontWeight};
	color: ${palette.secondary[500]};
`;

export const ContentValue = styled.span`
	font-weight: ${fonts.body.md.fontWeight};
	color: ${palette.secondary[500]};
`;

export const ContentNote = styled.p`
	font-size: ${fonts.body.sm.fontSize};
	font-weight: ${fonts.body.sm.fontWeight};
	line-height: ${fonts.body.sm.lineHeight};
	color: ${palette.secondary[300]};
	margin: 0;
`;

export const ContentSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const ContentSectionTitle = styled.h4`
	font-size: ${fonts.label.md.fontSize};
	font-weight: ${fonts.label.md.fontWeight};
	line-height: ${fonts.label.md.lineHeight};
	color: ${palette.secondary[400]};
	margin: 0;
`;

export const StyledActionPlanDrawer = styled(Drawer)`
	.ant-drawer-header {
		flex-direction: row-reverse;
	}

	.ant-drawer-header-title {
		flex-direction: row-reverse;
	}

	.ant-drawer-title {
		font-size: 25px;
		font-weight: 600;
		line-height: 32px;
		letter-spacing: -0.125px;
		color: #262626;
	}

	.ant-form-item-label > label {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		color: #262626;
		height: auto;
	}
`;

export const FactorDescriptionHeader = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
	font-weight: ${fonts.label.md.fontWeight} !important;
`;

export const FactorDescriptionText = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
`;

export const leftSummaryContainer = styled(Col)`
	padding-right: 12px;
`;

export const rightSummaryContainer = styled(Col)`
	padding-left: 12px;
`;